<template>
    <div>
        <skupovi-navigation
                :id="skup_id"
                :breadcrumbs="breadcrumbs"
        >
        </skupovi-navigation>
        <div class="ibox ">
            <div class="ibox-title">
                <h5>Kotizacija</h5>
            </div>
            <div class="ibox-content">
                <skup-kotizacija-forma
                        :disabled="false"
                        :id="null"
                        :modal="false"
                        :action="'create'"
                >
                </skup-kotizacija-forma>
            </div>
        </div>
    </div>
</template>

<script>
import SkupKotizacijaForma from "@/views/pages/Skupovi/SkupoviKotizacije/SkupKotizacijaForma";
import SkupoviNavigation from "@/views/pages/Skupovi/SkupoviNavigation";
export default {
name: "SkupKotizacijaCreate",
    components: {
        SkupKotizacijaForma,
        SkupoviNavigation
    },
    data(){
        return {
            breadcrumbs: [],
            skup_id: this.$route.params.skup_id,
            skup: {}
        }
    },
    methods:{
        setBreadcrumbs() {
            this.breadcrumbs = [
                {
                    path: '/skupovi/' + this.skup_id + '/kotizacije',
                    name: 'Kotizacije'
                },
                {
                    path: '/skupovi/' + this.skup_id + '/kotizacije/create',
                    name: 'Nova kotizacija'
                }
            ]
        },
    },
    mounted() {
        this.setBreadcrumbs()
    }
}
</script>

<style scoped>

</style>